export const Api = {
    postJson: async (url: string, csrfToken: string, reqBody: unknown) => {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'x-csrf-token': csrfToken,
                'content-type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(reqBody),
        })

        return response
    },

    post: async (url: string, csrfToken: string) => {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'x-csrf-token': csrfToken,
            },
            credentials: 'include',
        })

        return response
    },

    deleteJson: async (url: string, csrfToken: string, reqBody: unknown) => {
        const response = await fetch(url, {
            method: 'DELETE',
            headers: {
                'x-csrf-token': csrfToken,
                'content-type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(reqBody),
        })

        return response
    },

    getJson: async <T>(url: string): Promise<T> => {
        const response = await fetch(url, {
            method: 'GET',
            credentials: 'include',
        })

        return response.json()
    },
}
